import { render, staticRenderFns } from "./FileInput.modal.vue?vue&type=template&id=4563363e&scoped=true&lang=true&"
import script from "./FileInput.modal.vue?vue&type=script&lang=js&"
export * from "./FileInput.modal.vue?vue&type=script&lang=js&"
import style0 from "./FileInput.modal.vue?vue&type=style&index=0&id=4563363e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4563363e",
  null
  
)

export default component.exports